// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/cob-geo-ip/" + "cob-geo-ip.geo-targeting-modal.plugin" + "." + "3affbc" + ".js";
};